import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

const EDIT_MODE_LOCKED_FIELDS = [
  "agency",
  "surname",
  "Firstname",
  "Middlename",
  "appointmentDate",
  "position",
  "nonRegPosition",
];

class EmployeeRecordsFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  stripEditModeLockedFields() {
    if (!this.object?.id) {
      return;
    }

    for (const field of EDIT_MODE_LOCKED_FIELDS) {
      delete this.change[field];
    }
  }

  async save() {
    const collection = this.view.getCollectionName();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    const employmentType = this.change.employmentType;
    const selectedSchedule = this.change.selectedSchedule;
    const twentyFourSeven = this.change.twentyFourSeven;

    this.stripEditModeLockedFields();

    if (employmentType && Object.keys(employmentType).length) {
      this.change.employmentType = { id: employmentType.id };
    } else if (employmentType && !Object.keys(employmentType).length) {
      this.view.showError("Select at least one employment type");
      return;
    }

    if (selectedSchedule && Object.keys(selectedSchedule).length) {
      this.change.selectedSchedule = { id: selectedSchedule.id };
    } else if (selectedSchedule === null) {
      this.change.selectedSchedule = null;
    }

    if (employmentType?.id && this.change.id) {
      this.change.employment_type_assignment = {
        employeeId: this.change.id,
        name: employmentType.name,
      };
    }

    if (twentyFourSeven !== undefined && this.change.id) {
      this.change.twenty_fourSeven_assignment = {
        employeeId: this.change.id,
        name: twentyFourSeven,
      };
    }

    if (selectedSchedule?.id && this.change.id) {
      const { id, ...restData } = selectedSchedule;
      this.change.selected_schedule_assignment = {
        employeeId: this.change.id,
        ...restData,
      };
    }

    try {
      await this.upsertUseCase.execute(collection, this.change);

      this.showSuccess("Successfully Saved!");
      this.change = {};
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default EmployeeRecordsFormPresenter;
